export const participantRole = {
  CASE_OWNER_ID: 1,
  STAKEHOLDER_ID: 2,
  OBSERVER_ID: 3,
  BLOCKED_ID: 4,
  SILENT_OBSERVER_ID: 6,
}
